import styled from "styled-components";

export const StyledFADLogo = styled.img`
  width: 11rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 7.5rem;
    margin-bottom: 0.3rem;
    margin-left: -0.2rem;
  }
`;

export const FADLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DrugsAZDescriptionWithImage = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column-reverse;
  }
`;
